<template>
  <div>
    <Modal v-model="isShow" @on-ok="ok" :loading="loading" :mask-closable="false">
      <h3 slot="header" class="modal-header">智能化配置</h3>
      <div>
        <img class="imgwidth" v-if="intellectImg"  :src="intellectImg"/>
        <a href="javascript:;" style="vertical-align: bottom" @click="deleteItem()" v-if="intellectImg">删除</a>
        <Upload class="upload"
                :action="baseUrl+'/file/uploadFile'"
                :on-success="handleSuccess"
                :headers="{'Access-Token':token}"
                :show-upload-list="false"
                :on-error="handleError"
                :format="['jpg','jpeg','png']"
                :on-format-error="handleFormatError"
        >
          <Icon type="ios-plus-empty" size="40" style="vertical-align: middle"></Icon>
        </Upload>
      </div>
      <Input class="input-width" v-model="intellectClick" placeholder="跳转地址" v-if="intellectImg"/>
    </Modal>
  </div>

</template>

<script>
  import {houseTypeConfig, deleteIntellectImg} from "api/houseTypeConfig";
  import {getBaseUrl} from "@/utils/public";
  import {getToken} from "@/utils/auth";

  export default {
    name: "IntellectImg",
    props:{
      img:{
        type:String,
        default:''
      },
      click:{
        type:String,
        default:''
      },
      n: {
        type: Number,
        default: 0
      },
      fid:{
        type:String,
        default:''
      }
    },
    watch:{
      n(){
        // this.headImga=''
        // this.getProjectConfigInfo()
        this.isShow=true
      },
      img(val) {
        this.intellectImg = val
      },
      click(val) {
        this.intellectClick = val
      }

    },
    data(){
      return {
        isShow:false,
        token: '',
        baseUrl: '',
        intellectImg:'',
        intellectClick:'',
        loading:true
      }
    },
    methods:{
      deleteItem() {
        let params = {
          projectConfigFid: this.fid
        }
        deleteIntellectImg(params).then(res => {
          this.$Message.success('删除成功')
          this.changeLoading()
          this.$emit('refresh')
          this.isShow = false
        }).catch(error=>{})

      },
      ok(){
        this.houseTypeConfig()

      },
      handleError(){

      },
      handleFormatError() {
        this.$Message.error('请输入jpg,jpeg,png,格式的文件')
      },
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      handleSuccess(response){
        this.intellectImg = response.data.url
      },
      houseTypeConfig(){
        if(!this.fid || !this.intellectImg){
          this.changeLoading()
          this.$emit('refresh')
          this.isShow = false
          return
        }
        let data = {
          fid: this.fid,
          intellectImgUrl: this.intellectImg,
          intellectClickUrl: this.intellectClick
        }
        houseTypeConfig(data).then(res=>{
          this.$Message.success('智能化配置成功')
          this.changeLoading()
          this.$emit('refresh')
          this.isShow = false

        })
      }
    },
    created(){
      // this.getProjectConfigInfo()
      this.baseUrl = getBaseUrl()
      this.token = getToken()
    }

  }
</script>

<style scoped>
  .imgwidth{
    width: 150px;
    height: 100px;
    vertical-align: middle;
    /*margin-bottom: 20px;*/
  }
  .upload {
    display: inline-block;
    width: 150px;
    height: 100px;
    border: 1px dashed rgb(220, 220, 220);
    box-sizing: border-box;
    text-align: center;
    line-height: 100px;
    vertical-align: middle;
  }
  .input-width {
    width: 250px;
    padding:2px;
    /*margin-bottom: 10px;*/
  }

</style>
